<template>
  <div class="graph-container">
    <header><slot name="title"></slot></header>
    <div class="w-100 h-100 px-4 d-flex align-items-center">
      <ul class="w-100">
        <li v-for="(record, index) in dataSortedByCustomPropsType" :key="index" class="label">
          <slot name="label" v-bind="{ colors, index, record, othersData }">
            <slot name="label:category" v-bind="{ colors, index, record, othersData }">
              <div class="label-category text-truncate">{{ record[fields.category] }}</div>
            </slot>
            <div class="label-gauge"><span class="gauge" :style="`width: ${record.ratio > 100 ? 100 : record.ratio }%; background-color: ${colors[index]}`"></span></div>
            <slot name="label:value" v-bind="{ colors, index, record, othersData }">
              <div class="label-value">{{ record[fields.value] }}</div>
            </slot>
          </slot>
        </li>
      </ul>
  </div>
  </div>
</template>
<script>
import BaseGraph from "./_BaseGraph";

export default {
  extends: BaseGraph,
  props:{
    type: {
      type: String,
      required: false
    }
  },
  computed: {
    dataSortedByCustomPropsType(){
      if(!!this.type){
        return this.data.sort((a, b) => a[this.type] - b[this.type] )
      }
      return this.data
    }
  },
};
</script>
<style scoped>
.label {
  display: flex;
  align-items: center;
  font-size: .75rem;
  width: 100%;
}
.label-category {
  width: 30%;
}
.label-gauge {
  background-color: rgba(0,0,0, .1);
  border-radius: 3px;
  flex-grow: 1;
  height: .5rem;
  position: relative;
  margin: 0 .5rem;
}
.label-gauge > .gauge {
  display: inline-block;
  position: absolute;
  left: 0;
  top: 0;
  height: .5rem;
  border-radius: 3px;
  background-color: blue;
}
.label-color {
  display: inline-block;
  height: .75rem;
  width: .75rem;
  border-radius: 3px;
}
.label-value {
  text-align: right;
  width: 20%;
}
</style>
